import { jsx as _jsx } from "react/jsx-runtime";
import { SearchField } from '../../../search_field/src';
export const DropdownSheetSearch = ({ inputRef, onChange, onClear, placeholder, value }) => {
    const handleChange = (event) => {
        onChange(event.target.value);
    };
    return (_jsx("div", { className: 'nucleus-shrink-0 nucleus-px-4 nucleus-pb-2', onMouseDown: (event) => event.stopPropagation(), children: _jsx(SearchField, { ref: inputRef, ariaLabel: placeholder, autoComplete: 'off', dataTestId: 'nucleus-dropdown-search', onChange: handleChange, onClear: onClear, placeholder: placeholder, value: value, width: 'full' }) }));
};
//# sourceMappingURL=dropdown_sheet_search.component.js.map